import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonTheme } from '../../atoms/button/button';

/**
 * Table pagination component: it show's the next a prev button to continua in a split dataset
 * @param {*} props
 */
const TablePagination = (props) => {
  const {
    tableId,
    currentPage,
    firstPageUrl,
    from,
    lastPage,
    lastPageUrl,
    nextPageUrl,
    path,
    perPage,
    prevPageUrl,
    to,
    total,
    onChangePage,
  } = props;

  return (
    <div className="d-flex justify-content-between">
      <div>{`${from} to ${to} of ${total}`}</div>
      <div>
        { prevPageUrl !== null
        && (
          <Button
            id={`${tableId}-prevButton`}
            theme={ButtonTheme.LINK}
            onClick={() => onChangePage(prevPageUrl)}
          >
            Prev
          </Button>
        )}
        {`Page ${currentPage} of ${lastPage}`}
        { nextPageUrl !== null
        && (
          <Button
            id={`${tableId}-nextButton`}
            theme={ButtonTheme.LINK}
            onClick={() => onChangePage(nextPageUrl)}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

TablePagination.propTypes = {
  /**
   * Id of table
   */
  tableId: PropTypes.string,
  /**
   * The current page of the table
   */
  currentPage: PropTypes.number.isRequired,
  /**
   * Url with the dataset first page
   */
  firstPageUrl: PropTypes.string.isRequired,
  /**
   * Start element number shows in the table
   */
  from: PropTypes.number.isRequired,
  /**
   * Number of the dataset last page
   */
  lastPage: PropTypes.number.isRequired,
  /**
   * Url with the dataset last page
   */
  lastPageUrl: PropTypes.string.isRequired,
  /**
   * Next dataset url
   */
  nextPageUrl: PropTypes.string,
  /**
   * Inital path of the dataset
   */
  path: PropTypes.string.isRequired,
  /**
   * Items per page
   */
  perPage: PropTypes.number.isRequired,
  /**
   * Previus dataset url
   */
  prevPageUrl: PropTypes.string,
  /**
   * last item shows in the table
   */
  to: PropTypes.number.isRequired,
  /**
   * total of dataset elements
   */
  total: PropTypes.number.isRequired,
  /**
   * Event when the user click on next or prev page
   */
  onChangePage: PropTypes.func,
};

TablePagination.defaultProps = {
  tableId: '',
  prevPageUrl: null,
  nextPageUrl: null,
  onChangePage: () => {},
};

export default TablePagination;
